
export function convertCurrency(price: number, oldCurrency: string, newCurrency: string) {
	if (newCurrency == "EUR") {
		return price * 0.091
	}
	return price
}
